import React from "react";
import Card from "components/card";

const SummaryCard = ({
  title, 
  displayCount, 
  icon, 
  statusTag, 
  description, 
  textColor="text-white",
  iconColor,
}) => {
  const finalIconColor = iconColor || textColor;

  return (
    <Card className="bg-white text-slate-900 flex flex-col gap-6 rounded-xl border dark:bg-black/5">
      <div className="@container/card-header auto-rows-min grid-rows-[auto_auto] gap-1.5 px-6 pt-6 flex flex-row items-center justify-between pb-2">
          <h4 className="text-[14px] dark:text-white">
            {title}
          </h4>

          <div>
            {icon &&
              React.cloneElement(icon, {
                className: `${icon.props.className || ""} ${finalIconColor}`,
              })}
          </div>
      </div>

      <div className="px-6 pb-6">
        <div className={`text-[24px] flex font-semibold ${textColor} leading-none items-center space-x-2`}>
          <span>{displayCount}</span>

          {statusTag && (
            <span className="flex items-center bg-blue-50 text-blue-700 text-xs font-medium px-2 py-1 rounded-full">
              {statusTag}
            </span>
          )}
        </div>

        <div className="text-[12px] text-slate-700 dark:text-slate-100">
          {description}
        </div>
      </div>

    </Card>
    
  );
};

export default SummaryCard;
